<template>
  <section id="talk">
    <base-card>
      <v-card-title
        :class="[$vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1']"
        class="justify-center font-weight-bold grey--text text--darken-3 mb-3 text-center"
      >
        How does it work?
      </v-card-title>
      <v-container>
        <v-row>
          <v-col
            v-for="(feature, i) in features"
            :key="i"
            cols="12"
            md="4"
            sm="6"
          >
            <div class="text-center">
              <v-icon
                :color="feature.color"
                :size="64"
                class="mb-3"
                v-text="feature.icon"
              />
              <p
                class="text-justify text-md-center"
                style="font-weight:bold"
                v-text="feature.title"
              />
              <p
                class="text-justify text-md-center"
                v-text="feature.text"
              />
              <v-btn
                :exact="feature.exact"
                :to="feature.hr"
                :style="feature.display"
                @click="ctaclick('click','homePage',feature.cta)"
                v-text="feature.cta"
              />
            </div>
          </v-col>
        </v-row>
      </v-container>
      <v-divider class="my-5 mx-3" />
      <v-card-text class="text-left text-md-center title font-weight-light mx-auto mb-5">
        We contributed to the plantation of 4,860
        <v-icon color="green">
          mdi-tree
        </v-icon>
        trees since our inception in September 2019.
        <br><br>
        <div class="text-center">
          <v-btn
            target="_blank"
            href="https://edenprojects.org/user/rosian/"
            @click="ctaclick('click','homePage','See Progress Eden')"
          >
            See our progress
          </v-btn>
        </div>
      </v-card-text>
      <v-divider class="my-5 mx-3" />

      <v-card-title
        :class="[$vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1']"
        class="justify-center font-weight-bold grey--text text--darken-3 mb-3"
      >
        Top affiliate partners
      </v-card-title>
      <v-container>
        <v-row>
          <v-col
            v-for="(partner, i) in partners"
            :key="i"
            cols="12"
            md="4"
            sm="6"
          >
            <v-card
              class="mx-auto"
              max-width="344"
              outlined
            >
              <v-list-item three-line>
                <v-list-item-content>
                  <div
                    class="overline mb-4"
                    style="color:green;font-weight:800"
                    v-text="partner.commission_text"
                  />
                  <v-list-item-title
                    class="headline mb-1"
                    v-text="partner.name"
                  />
                  <v-list-item-subtitle
                    v-text="partner.description"
                  />
                </v-list-item-content>
                <v-avatar
                  size="80"
                >
                  <img
                    :src="partner.image"
                    :alt="partner.name"
                  >
                </v-avatar>
              </v-list-item>
              <v-card-actions>
                <v-btn
                  :href="partner.url"
                  target="_blank"
                  @click="ctaclick('clickPartner',partner.commission_text,partner.name)"
                  v-text="'Visit '+partner.name"
                />
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-card-text class="text-left text-md-center title font-weight-light mx-auto mb-5">
          <br>
          <div class="text-center">
            <v-btn
              class="pink lighten-4"
              to="partners"
              @click="ctaclick('click','homePage','View partners')"
            >
              See all partners
            </v-btn>
          </div>
        </v-card-text>
        <v-divider class="my-5 mx-3" />
      </v-container>
    </base-card>
  </section>
</template>

<script>
  export default {
    name: 'HomeContents',

    data: () => ({
      features: [
        {
          icon: 'mdi-shopping',
          color: 'pink',
          title: '1. You purchase',
          text: 'Use our partners\' links just before ordering online. Partners will send us referral commissions after your purchase.',
          cta: 'View partners',
          hr: 'partners',
          display: '',
          exact: false
        },
        {
          icon: 'mdi-tree',
          color: 'green',
          title: '2. Trees planted',
          text: `We donate 100% of the received commission to reforestation projects run by The Eden Reforestation Project charity.`,
          cta: 'Visit Eden',
          hr: 'https://edenprojects.org',
          display: 'display:none',
          exact: true
        },
        {
          icon: 'mdi-earth',
          color: 'indigo',
          title: '3. Everyone benefits',
          text: 'Cleaner air, richer wildlife, and fewer people are living in poverty! All this without the extra burden on customers.',
          cta: 'About us',
          hr: 'about-us',
          display: '',
          exact: false
        }
      ],
      partners: [
        {
          name: 'Hotels.com',
          description: 'Hotels, vacation rentals',
          commission_text: '3 trees per £10 spent',
          category: 'Travel',
          url: 'https://www.awin1.com/cread.php?s=626500&v=3617&q=309144&r=609935',
          image: 'https://rosian.org/images/partners/hotelscom-banner.jpg'
        },
        {
          name: 'Amazon Smile',
          description: 'Ecommerce, retail',
          commission_text: '1 tree per £20 spent',
          category: 'Ecommerce',
          url: 'https://smile.amazon.co.uk/ch/SC049614',
          image: 'https://rosian.org/images/partners/amazonsmile-banner.jpg'
        },
        {
          name: 'Ebay',
          description: 'Ecommerce, retail',
          commission_text: '3 trees per £10 spent',
          category: 'Ecommerce',
          url: 'http://rover.ebay.com/rover/1/710-53481-19255-0/1?icep_ff3=1&pub=5575511651&toolid=10001&campid=5338549260&customid=1&ipn=psmain&icep_vectorid=229508&kwid=902099&mtid=824&kw=lg',
          image: 'https://rosian.org/images/partners/ebay-banner.jpg'
        }
      ]
    }),
    methods: {
      ctaclick (pCat, pAct, pLab) {
        this.$ga.event({
          eventCategory: pCat,
          eventAction: pAct,
          eventLabel: pLab,
          eventValue: 1
        })
      }
    }
  }
</script>
